
import { Footer } from "../../../features/footer/footer";
import { JobCategories } from "../../../features/jobCategories/jobCategories";
import { OurApp } from "../../../features/news&locations/installApp";
import { Testimonials } from "../../../features/testimonials/testimonials";

export function Home() {
  // const token = useSelector(selectToken)
  // const [isLogin, setIsLogin] = useState(false)
  // useEffect(() => {
  //     if(token){
  //         setIsLogin(true)
  //     }
  // }, [token])
  return (
    <div>
      {/* <Dummy /> */}
      <JobCategories />
      <Testimonials />
      {/* <TopCompanies/> */}
      <OurApp />
      {/* <TopJobs /> */}
      {/* <News/> */}
      <Footer />
    </div>
  );
}
